import { render, staticRenderFns } from "./NotificationCenterFilterItem.vue?vue&type=template&id=2dfc89ce&scoped=true&"
import script from "./NotificationCenterFilterItem.vue?vue&type=script&lang=js&"
export * from "./NotificationCenterFilterItem.vue?vue&type=script&lang=js&"
import style0 from "./NotificationCenterFilterItem.vue?vue&type=style&index=0&id=2dfc89ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfc89ce",
  null
  
)

export default component.exports